__turbopack_context__.v({
  "clearSelection": "FlywaysMapFrame-module__0nexKa__clearSelection",
  "compactNav": "FlywaysMapFrame-module__0nexKa__compactNav",
  "compactOverlays": "FlywaysMapFrame-module__0nexKa__compactOverlays",
  "datazoneLink": "FlywaysMapFrame-module__0nexKa__datazoneLink",
  "filterCluster": "FlywaysMapFrame-module__0nexKa__filterCluster",
  "filterGroup": "FlywaysMapFrame-module__0nexKa__filterGroup",
  "filterHeading": "FlywaysMapFrame-module__0nexKa__filterHeading",
  "filterLabel": "FlywaysMapFrame-module__0nexKa__filterLabel",
  "filterList": "FlywaysMapFrame-module__0nexKa__filterList",
  "filterTab": "FlywaysMapFrame-module__0nexKa__filterTab",
  "filterTabActive": "FlywaysMapFrame-module__0nexKa__filterTabActive",
  "filters": "FlywaysMapFrame-module__0nexKa__filters",
  "legendClip": "FlywaysMapFrame-module__0nexKa__legendClip",
  "legendClipInner": "FlywaysMapFrame-module__0nexKa__legendClipInner",
  "legendClipOpen": "FlywaysMapFrame-module__0nexKa__legendClipOpen",
  "legendItem": "FlywaysMapFrame-module__0nexKa__legendItem",
  "legendLabel": "FlywaysMapFrame-module__0nexKa__legendLabel",
  "legendList": "FlywaysMapFrame-module__0nexKa__legendList",
  "legendSwatch": "FlywaysMapFrame-module__0nexKa__legendSwatch",
  "liveRegion": "FlywaysMapFrame-module__0nexKa__liveRegion",
  "mapColumn": "FlywaysMapFrame-module__0nexKa__mapColumn",
  "mapPlate": "FlywaysMapFrame-module__0nexKa__mapPlate",
  "root": "FlywaysMapFrame-module__0nexKa__root",
});
